import { z } from 'zod';

export const requestAccessSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, { message: 'First name is required.' })
    .max(100, { message: 'First name must be at most 100 characters long.' }),
  lastName: z
    .string()
    .trim()
    .min(1, { message: 'Last name is required.' })
    .max(100, { message: 'Last name must be at most 100 characters long.' }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'Email is required.' })
    .email({ message: 'Email must be a valid address.' })
    .max(255, { message: 'Email must be at most 255 characters long.' }),
  company: z
    .string()
    .trim()
    .min(1, { message: 'Company is required.' })
    .max(255, { message: 'Company must be at most 255 characters long.' }),
});

export type RequestAccessSchema = z.infer<typeof requestAccessSchema>;
